var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vyopta-filter-expression" },
    [
      _vm._l(_vm.getElements(), function (element, index) {
        return _c(
          "div",
          { key: element.key, staticClass: "elementContainer" },
          [
            element.type === "filter"
              ? _c("SingleFilter", {
                  ref: element.ref,
                  refInFor: true,
                  staticClass: "existingFilter",
                  attrs: {
                    columns: _vm.columns,
                    "dataset-name": _vm.datasetName,
                    excludedQuickPicks: _vm.excludedQuickPicks,
                    filter: element.filter,
                    "filter-id": element.filter.id,
                  },
                  on: {
                    "filter-remove-clicked": function ($event) {
                      return _vm.handleFilterRemoved(
                        element.groupId,
                        element.filter
                      )
                    },
                    "filter-selected": function ($event) {
                      return _vm.handleFilterAdded(element.groupId, $event)
                    },
                    "filter-on-click": _vm.handleFilterOnClick,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            element.type === "groupOperator"
              ? _c("div", { staticClass: "operatorContainer" }, [
                  _vm.mode === "simple"
                    ? _c("div", { staticClass: "simpleOperator" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode !== "simple"
                    ? _c(
                        "div",
                        {
                          staticClass: "operator pill clickable",
                          attrs: { tabindex: "0" },
                          on: {
                            click: (event) => _vm.operatorClick(event, index),
                          },
                        },
                        [
                          _c("span", { staticClass: "center-pill" }, [
                            _vm._v(_vm._s(element.group.operator)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectingOperator === index && _vm.mode !== "simple"
                    ? _c("div", { staticClass: "operatorSelect" }, [
                        _c(
                          "div",
                          {
                            class: {
                              pill: true,
                              selected: element.group.operator === "and",
                            },
                            attrs: { tabindex: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.groupOperatorSelect(
                                  element.groupId,
                                  "and"
                                )
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "center-pill" }, [
                              _vm._v("and"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: {
                              pill: true,
                              selected: element.group.operator === "or",
                            },
                            attrs: { tabindex: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.groupOperatorSelect(
                                  element.groupId,
                                  "or"
                                )
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "center-pill" }, [
                              _vm._v("or"),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            element.type === "addToGroup"
              ? _c("div", { staticClass: "addFilterContainer" }, [
                  _c(
                    "div",
                    {
                      staticClass: "addFilter pill",
                      attrs: {
                        title: "Add filter to this group",
                        tabindex: "0",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addFilterToGroup(element.groupId)
                        },
                      },
                    },
                    [_vm._m(0, true)]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            element.type === "expressionOperator"
              ? _c("div", { staticClass: "expressionOperator" }, [
                  _vm.mode !== "simple"
                    ? _c(
                        "div",
                        {
                          staticClass: "operator clickable",
                          on: {
                            click: (event) => _vm.operatorClick(event, index),
                          },
                        },
                        [_vm._v(_vm._s(_vm.localOperator))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectingOperator === index && _vm.mode !== "simple"
                    ? _c("div", { staticClass: "operatorSelect" }, [
                        _c(
                          "span",
                          {
                            class: {
                              operator: true,
                              selected: _vm.localOperator === "and",
                            },
                            attrs: { tabindex: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.operatorSelect("and")
                              },
                            },
                          },
                          [_vm._v("\n            and\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            class: {
                              operator: true,
                              selected: _vm.localOperator === "or",
                            },
                            attrs: { tabindex: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.operatorSelect("or")
                              },
                            },
                          },
                          [_vm._v("\n            or\n          ")]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "menuContainer", staticClass: "filterMenuContainer" },
        [
          _vm.showAddFilter()
            ? _c(
                "v-menu",
                {
                  ref: "menu",
                  staticClass: "filterMenu",
                  attrs: {
                    "content-class": "filterMenuContent",
                    attach: true,
                    bottom: "",
                    "nudge-bottom": "16",
                    left: "",
                    "nudge-left": "10",
                    "z-index": "900",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  attrs: {
                                    icon: "",
                                    height: "26",
                                    width: "26",
                                  },
                                  on: { click: _vm.filterMenuClick },
                                },
                                on
                              ),
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "filterMenuButton",
                                    attrs: { size: "14" },
                                  },
                                  [_vm._v("far fa-ellipsis-h")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2787248877
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "filterMenuListItem",
                          on: { click: _vm.addFilterGroup },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "filterMenuListItemIcon",
                              attrs: { small: "" },
                            },
                            [_vm._v("far fa-plus-circle")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "filterMenuListItemText" },
                            [_vm._v("Add New Group")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          staticClass: "filterMenuListItem",
                          on: { click: _vm.removeAll },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "filterMenuListItemIcon",
                              attrs: { small: "" },
                            },
                            [_vm._v("far fa-trash-can")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "filterMenuListItemText" },
                            [_vm._v("Delete All")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.shouldRenderApply
        ? _c("div", { staticClass: "HistoricalDatasetApplyButtonContainer" }, [
            _c(
              "button",
              {
                staticClass: "HistoricalDatasetApplyButton btn btn-primary",
                attrs: { disabled: !_vm.isFilterComplete },
                on: {
                  click: function ($event) {
                    return _vm.handleSubmit(
                      _vm.localOperator,
                      _vm.activeFilterGroups
                    )
                  },
                },
              },
              [_vm._v("\n        Apply\n      ")]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "center-pill" }, [
      _c("i", { staticClass: "fas fa-plus-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }